import { useEffect, useState, useRef } from 'react'
import { ANIMATION_DURATION, ANIMATION_STEPS } from './constants'

export const useIntersectionObserver = () => {
  const [isVisible, setIsVisible] = useState(false)
  const elementRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true)
      },
      { threshold: 0.3 }
    )

    observer.observe(element)
    return () => observer.unobserve(element)
  }, [])

  return { isVisible, elementRef }
}

export const useAnimatedPercentage = (
  targetPercentage: number,
  isActive: boolean
) => {
  const [currentPercentage, setCurrentPercentage] = useState(0)

  useEffect(() => {
    if (!isActive) {
      setCurrentPercentage(0)
      return
    }

    const step = targetPercentage / ANIMATION_STEPS
    const interval = ANIMATION_DURATION / ANIMATION_STEPS
    let current = 0

    const timer = setInterval(() => {
      current += step
      if (current >= targetPercentage) {
        setCurrentPercentage(targetPercentage)
        clearInterval(timer)
      } else {
        setCurrentPercentage(Math.floor(current))
      }
    }, interval)

    return () => clearInterval(timer)
  }, [isActive, targetPercentage])

  return currentPercentage
}
